import { RadioGroup, RadioGroupProps } from '@chakra-ui/react';
import React from 'react';

export const CmRadioGroup: React.FC<RadioGroupProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <RadioGroup {...{ ...rest }}>{children}</RadioGroup>;
};
